module.exports = __webpack_public_path__ + "img/digital_house_blue_mobile_1.png";